module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('img', {
    attrs: {
      "alt": "ship",
      "src": "image/ship.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Come on, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mr. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thompson,” I said to my homeroom ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("teacher. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Last period is only science ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("anyway.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The week before, I had made an enemy of Mrs. Faletoese when I proved to her in front of the whole class that, unlike other liquids, water expanded when it froze. She wouldn’t care if I ever showed my face in her class again.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Okay. Just don’t let Mr. Malo see you,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He ruffled my hair and gave me a little shove.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Now go, before everyone gets back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I ran between the classroom ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("fale ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from the gate and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mr. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Malo’s office, then circled around the basketball court at a casual walk, avoiding the kids making their ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("way ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("back to class. I ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gave ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a quick look around, then ducked through the hole in the fence by Mrs. Lupeli’s store. I sprinted to the harbor road, crossing just as a bright red, garishly decorated ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("aiga ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bus came jangling around the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("corner. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The driver slowed and I hopped aboard, handed him my quarter and dropped onto the wooden bench. A tapestry of tiny silver bells dangled in front of the open ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("window. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I could make out ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("anchored a mile ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tiny against the hills and buildings behind ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her mast was one of many in a cluster near Happy ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Valley ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I felt a thrill that I could pick her out amongst the other cruising boats even from this")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("distance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("She’s still there. Nobody’s noticed. Nobody cares.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("way ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to school that morning I saw that she was low in the water and I had been thinking about her all ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("day. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The bus rattled slowly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("around")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("past")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Taiwan")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("House")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Shipyard. I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pulled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bell")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cord")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("approached")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("canneries.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("driver slowed and I jumped out the back and ran up the steep and curving road toward Sean Murphy’s house.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph lived in Tuna ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Town, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the only American suburb in the South Pacific, a fenced-in tract of white split-levels carved into the lower slopes of Do’unami Ridge above the SunnySeas Tuna canning plant.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("got")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("top")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hill")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("SunnySeas")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("kids")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("came")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out of their little private school. They stared at me in my school uniform lavalava and I wished I had brought shorts to change into. Murph came up behind the group of kids and told them to beat it and they scattered. He was the oldest SunnySeas kid and was probably a foot taller than the rest. His father was the plant")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("manager.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s sinking,” I said. “Nobody’s taking care of her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That sucks. It’s a cool boat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’re going to save her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re dreaming again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked past him at a girl about my height who didn’t leave with the other kids. She had a nice skateboard, blue, with a kick tail and urethane mag wheels. She stepped on the tail of the board, flipped it into")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("air")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("caught")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("swing")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("arm,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("then")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("dropped")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and did it again. I forgot all about ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out in the harbor and Murph standing next to me. He turned and followed my gaze.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Scram, Tanya,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She glared at him and took a seat on the stump of a palm tree across")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("road,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("setting")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("skateboard")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("across")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lap.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blond")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hair was pulled back in a ponytail tucked through the strap of an old Red Sox cap. She wore cutoffs and her legs were")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sunburned.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Who’s that?” I whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“My little ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sister,” ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he said")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("loudly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“How come I’ve never seen her before?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She’s been at school in California,” he said. “Forget about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tanya eyed me from under her baseball cap. I grinned involuntarily and looked at the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Earth to Gabe,” Murph was saying in my ear. “You said ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sinking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh, yeah,” I said, turning back to him. “Lloyd’s meeting us there. We need your skiff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Man, you know my Mom won’t let me cross the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Murph,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("put")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("towline")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(",")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she’s")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ours.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Salvage rights, like in ")]), _c('span', {
    staticClass: "ORIM-Ital CharOverride-4"
  }, [_vm._v("Grey Seas Under")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph looked down over the tuna factories, their acres of glinting galvanized roofing spread out below us. He squinted to see across the harbor to where ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lay at anchor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Salvage rights?” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“This is our chance,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He glanced across the road at Tanya.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve got to ditch her,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I can hear, you know,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She dropped the skateboard onto the ground, stood up, and held it with one foot. Her knee had a fresh scrape.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m coming with you guys.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Go home, Tanya,” Murph said. “I mean it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What’s ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“None of your beeswax. And don’t say a fucking word about where we’re going.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re an asshole, Sean,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He grabbed my arm and gave me a little shove down the hill.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why she can’t come?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’ve got a problem, dude. She’s fucking sixteen ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she’s my little sister.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("I’m ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fifteen,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph spat on the hot pavement and we started walking toward the cannery. I looked back at Tanya. She was flipping the skateboard with her foot again. I gave her a shrug of apology. She just looked at me before turning and gliding away on her skateboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph’s skiff had a British Seagull outboard motor so old and cantankerous that only he could start it and keep it running. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shinnied down a piling into the boat and I cast off while he lovingly wiped down the black and chrome ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("motor, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("checked the gas, and wrapped the starter cord around the flywheel. With a sharp tug and some")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("deft")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("adjustment")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("choke,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("got")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("motor")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("popping")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and pinging and we were ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("underway, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the warm air laced with oily gasoline exhaust from the outboard and the pungent smell of tuna from the long-liners. The afternoon clouds were beginning to pile on ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Fa’atui ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to windward, but the sun still shone down the length of ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Harbor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“So the freak is going to be there too?” Murph asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t call him that. He’s a good kid. And we need him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Whatever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was lower in the water and down by the head, her mast raking forward. Lloyd paddled over as we pulled alongside.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Why’d you bring him?” Lloyd asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“He needs me,” said Murph. “Why are you here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Fuck off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We all climbed aboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Let’s do a bucket brigade,” I said. “Who wants to go below first?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I slid open the hatch and we all leaned over the coaming and then recoiled immediately. Floating face down in")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("oily")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("slick")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bilgewater")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("headless")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("body,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("arms")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("legs")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("spread-eagled")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("over")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("floating floorboards.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We looked at each other, holding our breath, then peered back down into the dark cabin. A pair of Ohio Dave’s jeans and a long-sleeved shirt floated in the murk. I exhaled long and slow.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Jesus H. Christ,” said Lloyd.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m not going down there,” said Murph.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t tell me you believe in ghosts,” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m allergic to mildew,” Murph said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He sneezed to confirm this and stepped back into the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re a couple of old ladies,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I descended the companionway ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ladder, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("carrying the deck bucket, threw")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("soggy")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("clothes")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hatch")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("started")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bail.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("soon")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("got into a rhythm with me dipping the bucket and passing it up by the bail to Lloyd, standing on the top step. He swung it to Murph, who dumped it over the rail. Some of the floorboards floated around my ankles and I had to feel around with my toes so I wouldn’t fall into the bilge. When I was tired, Lloyd and I changed places and gradually the water retreated back to the bilge and the soaking wet cabin sole emerged like a drying reef.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("took")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("break")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("topside")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lit")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cigarette,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("offering")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("me")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one from his upturned pith helmet.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Not now,” I said, still breathing heavily.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph had opened the small hatch aft of the cockpit and was rummaging around in the lazarette locker. Lloyd didn’t offer him a cigarette.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Man, am I the best or what?” Murph said suddenly, holding up a T-shaped bilge pump handle about three feet long.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He stood holding the handle triumphantly in one hand like an Olympic torch and even Lloyd had to laugh. He found the bronze deck plate covering the head of the bilge pump and threaded on the handle. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("took turns at the pump, spewing bilgewater out into the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" hour, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pump")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sucked")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("air")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("boat")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sat")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("level again, her jaunty sheer sweeping up toward the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bow.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“If we don’t find the leak, we’re going to be doing this again tomorrow,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Could be anywhere,” said Lloyd.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He tried to blow a smoke ring, but the wind carried it away before it could form.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("found the pump handle,” said Murph, settling comfortably into one corner of the cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Losers,” I said, and went back below deck. Lloyd followed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bilge")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("water")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("no")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("longer")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sloshing")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("around,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("could hear the trickle of a little stream somewhere back aft somewhere. The engine was squeezed under a low bridge deck at the aft end of the cabin, with less than a foot between the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("valve ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cover and the deck beams. Lloyd crawled in alongside the motor until just his feet and freckled legs were sticking out.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There’s a cracked pipe,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Must be from the explosion,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We need some duct tape or something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Let me see,” I said and Lloyd backed out from the tight space. The salt water intake pipe was cracked just above the through-hull fitting, the water flowing through in a steady freshet. I closed the through-hull valve and the water stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Done,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I inched back into the cabin and stood up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That was easy,” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There was a seacock,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Cock?” Lloyd said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s a valve, shithead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Now you’re Mr. Marine Mechanic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s not exactly the ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Apollo")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Well, you’re lucky you’re such a stick-man,” Lloyd said, “or you’d never fit under there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("looked")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("each")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("then")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("who")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("come")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down the ladder into the cabin: all three of us were just skin, bones and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sinew, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not an ounce of spare muscle or fat between us. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("all started to laugh.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Did you really fix it then, Jesus-freak?” Murph asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Of course, you dumb mick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Long live the stick-men!” I said, and we all raised our fists in triumph.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve got to get this boat cleaned out, get rid of some of this crap,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Let’s tow it over to SunnySeas,” Murph said. “My dad won’t ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("care.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Her,” ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I said. “Let’s tow ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("her ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("over to SunnySeas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Got it, Melville.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The first afternoon rainsquall was tumbling over Fa’atui and sweeping")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("harbor")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("when")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("we")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("came")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("deck.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bobbed and tugged at her mooring. The tuna cannery was half a mile across the harbor broad on the port ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bow, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the water choppy with a few whitecaps. The other cruising boats were downwind of us, ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one of the closest, maybe two hundred yards")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("getting")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("too")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("breezy,”")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("said.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Seagull’s got the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("horsepower.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sure it does,” said Murph. “We’ve got to get a towline on this thing and make our claim.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“It’s too windy to tow,” I said. “We’ve got to take her on the hip.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Bullshit. I can tow in more wind than this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ll have more fucking control on the hip.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You always think you’re in charge, Gabe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd lit another cigarette and watched us arguing, a hint of a smirk on his face. He strolled up to the foredeck and cast off the mooring pennant. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was adrift.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Make up your minds, ladies,” he said. “Salvage rights or shipwreck?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Lloyd, you dumb-ass.” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("began to blow astern, and her bow swung off to port until she lay beam-on to the wind. Murph cursed, jumped into his skiff and tugged the outboard to life.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“On the hip,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph ignored me, maneuvered up to the bow of ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", and handed Lloyd the stern-line attached to a ring-bolt on the transom of the skiff. A gust of wind caught the boat broadside, giving her a little heel. Murph throttled up his ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("motor, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("took a strain on the towline and immediately the skiff veered to windward, the stern of the little boat pulled by the tension on the towline. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("continued to drift downwind toward the group of yachts, even as the squall set in and the rain came down in fat drops, shutting the visibility down to a few boat lengths. Lloyd’s canoe banged alongside as ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("made ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sternway.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The strain on the towline forced the stern of the skiff deep into the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("water")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("wave ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tops")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("began")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("splash")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("into")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("boat.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murphy")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("didn’t look so confident any more. I’m sure I didn’t ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("either. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Another gust slammed into ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and she heeled, tugging the skiff backwards. Green water poured in over the stern and the skiff settled ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lower. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph eased the throttle and started to bail. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bow blew farther")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("off")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("she")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("began")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("pick")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("speed")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("downwind,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nearly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("running over the sluggish skiff. Murph looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“If my parents find out, I’m a dead man,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd’s cigarette had gone out and started to disintegrate in the rain. He was eyeing his canoe as though he might make a break for shore.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Don’t")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("even")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("think")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("about")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it,")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Lloyd,” ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("said.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You’re")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("who")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cast us ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd looked up at me and pointed over my shoulder to where ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole’s")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bowsprit")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("appeared")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("battering")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ram")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rain. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were drifting almost broadside and I imagined what was coming next: the rigging of the two boats tangling, the topsides grinding ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("together.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Lloyd, cast off the towline,” I said. “Now!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd untied Murph’s stern-line and the skiff drifted away to windward, Murph bailing madly. Pushed by the wind in her rigging, ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("slowly bore off and gained speed, running downwind straight towards ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The air was dense with wind-driven rain. Dad materialized on the foredeck in the rain and cupped his hands to make a megaphone.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What kind of goddamn stupid-ass, dumb-shit stunt is this?” he yelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I held the tiller down, praying that ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("would make the turn")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("port")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sharp")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("enough")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("clear")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole’s")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("main")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rigging.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("began to respond quicker and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("quicker, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but it was going to be close. Dad ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("holding a machete ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("now, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("probably to cut ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tangled rigging before the boats could smash ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("together. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was drenched and looked like Blackbeard about to board. Then ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("turned playfully and ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ran ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down alongside ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("starboard side, close to be sure, but ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("clear, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and safe enough. The canoe trailed safely astern and Murph in the now bailed-out skiff shadowed us a boat length")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Salvage rights,” I shouted at my father. “She was sinking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Load of crap,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I made a turn to starboard around ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Seminole")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(", away from the fleet, and into open water.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Murph, come alongside to port, right here on the hip on the lee side. Lloyd, bring a fender aft.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("boys")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("moved")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("without")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hesitation")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("time")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("brought the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("skiff")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("around")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("stern.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("quickly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tied")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("snug")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("alongside")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with two breast lines and a spring line back from the bow of the skiff to the jib sheet winch. ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("protected the skiff from the chop and Murph throttled up on my signal, the thrust immediately transferred into forward movement. The bigger boat responded to her helm as she")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("picked")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("speed.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("warm")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rain")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("continued")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("come")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("so")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("thick I couldn’t see more than fifty yards ahead. I yanked the canvas")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cover off the binnacle to see the compass.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Lloyd, what do you think the bearing is to the cannery from here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Bearing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Shit,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("just")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("steer")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("northeast")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("while")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("find")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("chart,”")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shouted,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Murph, keep her at two-thirds throttle and don’t run out of")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd took the tiller and stared at the compass. Murph kept one hand")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("throttle.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ohio")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dave’s")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("charts")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("blackened")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fire and crumbled when I tried to pull one free. I went back on deck and into the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("suddenly")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("swept")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("down")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("upon")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("us,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("squall")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("passed,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and we could make out the tuna fleet massed at the wharves ahead. The green slopes of the mountains towered above the glinting canneries. The wind eased and steam rose from ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("decks and the decks of the fishing fleet, the roofs of the factories and the deep emerald jungle on the mountainsides. I stood up on the cabin top and leaned over the furled mains’l, surveying the crowded scene at the wharves ahead. The Seagull outboard purred and the little island sloop and its towboat chuckled along across ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Tongu")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Harbor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ll bring her in on the hip,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“OK, Cap,” said Lloyd, Murph gave a little salute and grinned, waiting for a signal, his hand on the tiller of the old outboard.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lloyd spat out his cigarette and expelled the smoke from his lungs. He had gone forward to get a bow line ready and was the first to see around the long-liner at the end of the wharf as ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("eased in toward the shore.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Shit,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murph’s dad stood on the wharf with his hands on his hips. Next to him was a rotund Ma’atean policeman in a blue ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("lavalava ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("very much like my school uniform. I signaled Murph, palm down, to ease the throttle and then gestured for neutral, letting ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly’s ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("five tons glide towards the pilings. She was a hundred times heavier than anything I had ever handled in close quarters, but the curved, teak tiller felt light and comfortable in my hand, and ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("turned smartly, kissing the dock as she lay alongside.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sean")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murphy!”")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mr.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murphy")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("said,")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("devil")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("doing out in that squall?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The wharf was about eight feet high and the fat cop moved towards the edge to peer down at us.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I’m sorry, Dad. Gabe asked me to help with the salvage,” said Murph.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Salvage?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was sinking, sir,” I said, “and I needed Sean’s help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Gabriel, you know the rules. Why are you always horsing around in the harbor anyway?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("live ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in the harbor, sir,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was soaked to the skin, my white school shirt filthy from crawling around next to the engine. Mr. Murphy glanced at Lloyd, who was bailing out his canoe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“What a bunch of water rats,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Simply messing about in boats, sir,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You had us worried, especially Sean’s mother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Should I make a report then?” the cop asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Just tell the chief the boys were saving the boat from sinking, the one that blew up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The cop leaned gingerly over the edge of the wharf, looking down at the boat. I imagined for a second what would happen to ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly")]), _c('span', {
    staticClass: "ORIM-Ital"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fell")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("her")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("from")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("up")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("there.")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("took")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("small")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("notepad.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Your family?” he asked. “And how old are your ages?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He jotted our names and ages on his pad, ending with a flourish of the pen that nearly upset his balance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“And Mrs. Murphy?” he asked. “Should I have words of assurance to her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Sean will handle that,” said Mr. Murphy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“This idea is good,” said the policeman.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("turned ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and waddled off toward the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cannery ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("gates. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mr. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Murphy descended the ladder and stepped nimbly onto the side deck. The ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("sloop bobbed and then adjusted to his weight. He looked ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("aloft ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and gave the ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("rigging ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("little ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shake, then made his way ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("aft ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to the")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("cockpit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“So what’s all this about salvage, then?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve been watching her,” I said, “ever since the fire.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She looked funny this morning, low in the water, so Gabe and I made a plan,” said Lloyd. “We pumped her out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“There was a cracked intake pipe,” I said. “But Sean really saved the day with his skiff, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sometimes it made me sick how proud Mr. Murphy was of his son, but at this point I wanted to press the advantage. He looked at Sean sternly, but I could see both of them relax.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Will they let us keep her, Dad?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Mr. Murphy looked down the hatch, studied the damp wreckage, the strewn tools, engine parts, and personal gear.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“This salvage thing won’t hold water in court,” he said, “but I don’t think anyone wants ")]), _c('span', {
    staticClass: "ORIM-Ital"
  }, [_vm._v("Plumbelly ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("anymore, boys.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Something in his voice made us pause and wait for the other shoe to drop.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“This boat killed a man,” he said. “She may have a taste for blood.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da16472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plumbelly7.vue
// module id = 84
// module chunks = 0